import {
  GET_RESERVATION_REQUEST,
  GET_RESERVATION_BY_EMAIL_RESERVATIONNUMBER_REQUEST,
  LIST_RESERVATIONS_REQUEST,
  RESET_RESERVATION_QUERY
} from './constants';

export const listReservations = (queryString) => ({
  type: LIST_RESERVATIONS_REQUEST,
  queryString
});

export const getReservation = (reservationId) => ({
  type: GET_RESERVATION_REQUEST,
  reservationId
});

export const getReservationByEmailReservationNumber = (
  email,
  reservationNumber
) => ({
  type: GET_RESERVATION_BY_EMAIL_RESERVATIONNUMBER_REQUEST,
  email,
  reservationNumber
});

export const resetReservationQuery = () => ({
  type: RESET_RESERVATION_QUERY
});
